import { BulkAction, RunningBulkAction } from './types/articleItem';

const TITLE_MAX_LENGTH = 40;

const actionMap: Record<BulkAction, string> = {
  'approve-all': 'approval',
  'archive-all': 'archiving',
  'reject-all': 'rejection'
};

export function getToastErrorMessage(action: BulkAction, title: string): string {
  return `An error occurred while initiating the ${
    actionMap[action]
  } process. Please try again later.(${getTruncatedTitle(title)})`;
}

function getTruncatedTitle(title: string): string {
  return title.length > TITLE_MAX_LENGTH ? `${title.slice(0, TITLE_MAX_LENGTH)}...` : title;
}

export function getToastSuccessMessage(action: BulkAction, title: string): string {
  return `The ${
    actionMap[action]
  } process for all pending comments for the selected article is done.(${getTruncatedTitle(title)})`;
}

export function getRunningBulkActionByPostId(
  postId: string,
  runningBulkActions: RunningBulkAction[]
): BulkAction | null {
  const runningBulkAction = runningBulkActions.find(({ postId: runningPostId }) => runningPostId === postId);

  return runningBulkAction ? runningBulkAction.action : null;
}
